module.exports = "<div class=\"alert-container row\">\n  <div class=\"col-sm-4 col-sm-offset-4\">\n    <div *ngFor=\"#message of service.messages; #i = index\"\n    [ngClass]=\"getCssClass(message)\"\n    class=\"alert alert-dismissible text-center\">\n    <button type=\"button\"\n    class=\"close\"\n    (click)=\"service.dimiss(i, message)\">×</button>\n    {{ message.text }}\n  </div>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/alert/alert.html
 ** module id = 320
 ** module chunks = 2
 **/